import { useState } from 'react';

export default function Testimonials() {
  const testimonials = [
    {
      id: 1,
      quote: 'Thomas joined us as a surprise for the last dinner of our corporate retreat, and it couldn\'t have been better. He involved everyone, and had the whole group laughing together.',
      author: 'Sarah Araujo',
      role: 'HR',
      company: 'Alster Cyber Solutions',
      image: 'https://public.readdy.ai/ai/img_res/8fbd1eaf5c08fac65e6dc99651955c49.jpg'
    }
  ];

  return (
    <section className="relative py-32 px-6 bg-black">
      <div className="max-w-6xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-20">
          <h2 className="text-5xl md:text-6xl font-bold text-white mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
            Client <span className="bg-gradient-to-r from-red-600 to-red-400 bg-clip-text text-transparent">Testimonials</span>
          </h2>
          <p className="text-gray-400 text-lg">
            What corporate clients and event planners say about working with Thomas
          </p>
        </div>

        {/* Single Testimonial */}
        <div className="bg-zinc-900 rounded-2xl border border-zinc-800 p-12 md:p-16">
          <div className="flex flex-col md:flex-row items-center gap-12">
            {/* Content */}
            <div className="flex-1 text-center md:text-left">
              <p className="text-2xl md:text-3xl text-white mb-8 leading-relaxed italic" style={{ fontFamily: 'Playfair Display, serif' }}>
                "{testimonials[0].quote}"
              </p>
              
              <div>
                <h4 className="text-xl font-bold text-white mb-1">
                  {testimonials[0].author}
                </h4>
                <p className="text-red-400 text-sm font-medium mb-1">
                  {testimonials[0].role}
                </p>
                <p className="text-gray-500 text-sm">
                  {testimonials[0].company}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
